import { node, string } from 'prop-types';
import clsx from 'clsx';
import { useLayout } from './hook';
import { useMediaQuery } from '@mui/material';
import Sidebar from 'components/Sidebar';
import { sections } from 'components/Sidebar/items';
import { useAuth } from 'core/contexts/auth';
import { useHistory } from 'react-router-dom';

const Layout = ({ children, contentClassName, isHome = false }) => {
    const { classes, open, toggleMenu } = useLayout();
    const { logout } = useAuth();
    const history = useHistory()

    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const drawerWidth = isMobile ? '100vw' : 264;

    const contentShiftStyles = open
        ? {
              marginLeft: drawerWidth,
              maxHeight: '100vh',
              maxWidth: '100vw',
              overflow: 'hidden',
              padding: isMobile ? 0 : '',
          }
        : {};

    const onLogoutClick = async () => {
        await logout();
        history.push('/');
    };

    return (
        <>
            <Sidebar open={open} toggleMenu={toggleMenu} sections={sections} onLogoutClick={onLogoutClick}/>
            <main className={clsx(classes.content, contentClassName)} style={contentShiftStyles}>
                {children}
            </main>
        </>
    );
};

Layout.propTypes = {
    children: node.isRequired,
    contentClassName: string,
};

Layout.displayName = 'Layout';

export default Layout;
